import { useEffect, useState } from "react";
// import {
//   getOrgDetails,
//   saveOrgDetails,
// } from "../../services/adminConfigService";

import "./AdminConfig.css";
import { useUser } from "../../context/AuthContext";


const GROUP_ID = "AABFXWN";

const OrgDetailsConfig = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { user } = useUser();


    const [org, setOrg] = useState({
        groupId: GROUP_ID,
        orgName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        country: "India",
        currency: "INR",
        timeZone: "Asia/Kolkata",
        isActive: true,
    });

    const update = (k, v) => setOrg((p) => ({ ...p, [k]: v }));

    useEffect(() => {
        // user context still loading
        if (user === undefined) return;

        // no user
        if (!user || !user.data) {
            setLoading(false);
            return;
        }

        const u = user.data; // ✅ IMPORTANT

        console.log("Mapped user data 👉", u);

        const primaryGroup = u.Groups?.[0];

        setOrg({
            groupId: primaryGroup?.GroupId ?? GROUP_ID,
            orgName: primaryGroup?.GroupName ?? "",
            email: u.Email ?? "",
            phone: u.Mobile ?? "",
            address: [
                u.DoorNo,
                u.ApartmentName,
                u.Street,
            ]
                .filter(Boolean)
                .join(", "),
            city: u.City ?? "",
            state: u.State ?? "",
            country: "India",
            currency: "INR",
            timeZone: "Asia/Kolkata",
            isActive: true,
        });

        setLoading(false);
    }, [user]);



    const handleSave = async () => {
        // try {
        //   setSaving(true);
        //   await saveOrgDetails(org);
        //   alert("Organization details saved");
        // } catch (e) {
        //   alert("Save failed");
        // } finally {
        //   setSaving(false);
        // }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <section className="config-card">
            <h3>Organization Details</h3>

            <div className="form-grid">
                <input
                    placeholder="Organization Name"
                    value={org.orgName}
                    onChange={(e) => update("orgName", e.target.value)}
                />
                <input
                    placeholder="Email"
                    value={org.email}
                    onChange={(e) => update("email", e.target.value)}
                />
                <input
                    placeholder="Phone"
                    value={org.phone}
                    onChange={(e) => update("phone", e.target.value)}
                />
                <input
                    placeholder="Address"
                    value={org.address}
                    onChange={(e) => update("address", e.target.value)}
                />
                <input
                    placeholder="City"
                    value={org.city}
                    onChange={(e) => update("city", e.target.value)}
                />
                <input
                    placeholder="State"
                    value={org.state}
                    onChange={(e) => update("state", e.target.value)}
                />
            </div>

            <button
                className="primary"
                onClick={handleSave}
                disabled={saving}
            >
                {saving ? "Saving..." : "Save"}
            </button>
        </section>
    );
};

export default OrgDetailsConfig;
